import { useMutation, useQueryClient } from "@tanstack/react-query";
import { contextsKeys } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  apiPut,
  getApiUrl,
  putUsersProfilePhotoPath,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { getUserInfoAsync } from "State/Auth/UserInfo/GetUserInfoState";
import appStore from "State/Store";

type Parameters = {
  file: Blob;
};

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useUploadProfilePhotoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      async ({ file }: Parameters) => {
        const form = new FormData();
        form.append("file", file);

        return apiPut(`${getApiUrl()}${putUsersProfilePhotoPath()}`, form, {});
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      // The context switcher shows per-persona avatars from the contexts query.
      queryClient.invalidateQueries({ queryKey: contextsKeys.all });
      appStore.store.dispatch(getUserInfoAsync.request(undefined));
      onSuccess?.();
    },
    onError,
  });
};
